import React from 'react';
import PropTypes from 'prop-types';

class ActivityPic extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <a href={content.url} target="_blank" rel="noopener noreferrer">
                <img src={content.src} />
            </a>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
ActivityPic.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
ActivityPic.defaultProps = {};

export default ActivityPic;
